import { FlexBox, IconButton } from '@dixa/lib-shared-habla';
import moment from 'moment-timezone';
import { useCallback, useState } from 'react';

import {
  getNextMonthWithYear,
  getPreviousMonthWithYear,
} from 'components/settings/components/sections/openingHours/views/schedule/utils/date';

import { useScheduleContext } from '../../../../schedule.context';
import { Calendar, MonthAndYear } from '../calendar/calendar';
import { getCurrentDate } from '../calendar/utils/date';

import styles from './preview.module.scss';

const monthNames = moment.months();
const { year: currentYear, month: currentMonth } = getCurrentDate();

export function Preview(): JSX.Element {
  const [monthAndYear, setMonthAndYear] = useState<MonthAndYear>({
    year: currentYear,
    month: currentMonth,
  });

  const { initialSchedule } = useScheduleContext();

  const onPreviousMonth = useCallback(
    () =>
      void setMonthAndYear((prevMonthAndYear) =>
        getPreviousMonthWithYear(prevMonthAndYear),
      ),
    [],
  );

  const onNextMonth = useCallback(
    () =>
      void setMonthAndYear((prevMonthAndYear) =>
        getNextMonthWithYear(prevMonthAndYear),
      ),
    [],
  );

  const isBeforeScheduleCreated = moment
    .utc(monthAndYear)
    .isBefore(moment.utc(initialSchedule?.created_at));
  const isPreviousDisabled =
    (monthAndYear.year === currentYear - 1 &&
      monthAndYear.month === currentMonth) ||
    isBeforeScheduleCreated;

  const isNextDisabled =
    monthAndYear.year === currentYear + 1 &&
    monthAndYear.month === currentMonth;

  return (
    <FlexBox maxHeight="100%" flexDirection="column">
      <div className={styles.head}>
        <h2 className={styles.heading}>
          {`${monthNames[monthAndYear.month]} ${monthAndYear.year}`}
        </h2>
        <FlexBox gap="100">
          <IconButton
            className={styles.arrow}
            disabled={isPreviousDisabled}
            icon="angle-left"
            onClick={onPreviousMonth}
            size="large"
            variant="secondary"
          />
          <IconButton
            className={styles.arrow}
            disabled={isNextDisabled}
            icon="angle-right"
            onClick={onNextMonth}
            size="large"
            variant="secondary"
          />
        </FlexBox>
      </div>

      <Calendar monthAndYear={monthAndYear} />
    </FlexBox>
  );
}
